/**
 * Liga o guardião da sessão (GUPM-336) ao client do app. Chamar UMA vez, na raiz (`App`),
 * como o `useClearCacheOnSignOut`.
 */
import { useEffect } from 'react';
import { supabase } from '@/lib/supabase';
import { iniciarGuardiaoDaSessao } from '@/lib/guardiao-da-sessao';
import { relogioDesregulado, descreverDesvio } from '@/domain/sessao/relogio';
import { useRelogioStore } from '@/stores/relogioStore';

export function useGuardiaoDaSessao(): void {
  useEffect(
    () =>
      iniciarGuardiaoDaSessao(supabase.auth, (desvioMs) => {
        if (desvioMs !== null && relogioDesregulado(desvioMs)) {
          console.warn(`[sessao] relógio deste computador está ${descreverDesvio(desvioMs)}`);
        }
        useRelogioStore.getState().setDesvio(desvioMs);
      }),
    [],
  );
}
